module.exports = __webpack_public_path__ + "img/synaplus_logo_square_outlinev2.7d44361c.svg";